// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2jinh","savePackageButton":"ClientWallet_savePackageButton__2ueRn"};